import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import HeaderUser from "./content/header";
import CarouselIndex from "../pages/content/carrouselindex"
import FeaturesIndex from "../pages/content/featureindex"
import Footer from "../pages/content/footer"
import {Helmet} from 'react-helmet'


class Index extends Component {


  render() {
    return (
      <React.Fragment>
        
        <HeaderUser />
        <br></br>
        <CarouselIndex />
        <FeaturesIndex />

      <Footer />
      </React.Fragment>
       
    );
  }
}

export default withRouter(Index);


// WEBPACK FOOTER //
// ./src/pages/index.js